module.exports = __webpack_public_path__ + "img/logo-light.3e57fce7.png";